module.exports = __webpack_public_path__ + "static/img/WechatIMG214.d443c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/WechatIMG214.png
// module id = thrG
// module chunks = 13